import Default from "../Pages/Dashboard/Default/Default";
import RechargeAmountGrid from "../Pages/SamplePage/RechargeAmountGrid";
import RechargeHistory from "../Pages/Application/Master/book_ticket/RechargeHistory";
import AccountSettings from "../Pages/SamplePage/AccountSettings";
import AccountProfile from "../Pages/SamplePage/AccountProfile";


const cardRechargeCRoutes = [
  // dashboard
  { path: `${process.env.PUBLIC_URL}/dashboard/default`, Component: <Default /> },
 // Account
   { path: `${process.env.PUBLIC_URL}/account/account_settings`, Component: <AccountSettings /> },
   { path: `${process.env.PUBLIC_URL}/account/account_profile`, Component: <AccountProfile /> },
 
  // { path: `${process.env.PUBLIC_URL}/recharge/card_recharge`, Component: <RechargeAmountGrid /> },
  // { path: `${process.env.PUBLIC_URL}/recharge/recharge_history`, Component: <RechargeHistory /> },
];

export default cardRechargeCRoutes;
